import { render, staticRenderFns } from "./AccreditationEventSettingsForm.vue?vue&type=template&id=1c0f77ac&scoped=true"
import script from "./AccreditationEventSettingsForm.vue?vue&type=script&lang=js"
export * from "./AccreditationEventSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f77ac",
  null
  
)

export default component.exports